export const server = process.env.REACT_APP_CORE_API;
// move to .env
